export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="font-heading text-lg font-bold text-background-50">腐漫画网</h4>
            <p className="mt-3 text-xs md:text-sm text-background-300 leading-relaxed">
              腐漫画网集结韩漫腐、韩漫耽美、日漫腐、国漫耽美等风格腐漫，精选好看腐漫与热门腐漫推荐，免费全集下拉式随心看。每日更新，纯净阅读，为腐漫爱好者打造最好的在线阅读平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">快速导航</h4>
            <nav className="mt-3 flex flex-col gap-2">
              <a href="#hero" className="text-xs md:text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap">首页</a>
              <a href="#index" className="text-xs md:text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap">专题合集</a>
              <a href="#cards" className="text-xs md:text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap">精选推荐</a>
              <a href="#ranking" className="text-xs md:text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap">人气排行</a>
              <a href="#faq" className="text-xs md:text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap">常见问题</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">热门分类</h4>
            <nav className="mt-3 flex flex-col gap-2">
              <span className="text-xs md:text-sm text-background-300 whitespace-nowrap">韩漫腐完结推荐</span>
              <span className="text-xs md:text-sm text-background-300 whitespace-nowrap">日漫腐经典必读</span>
              <span className="text-xs md:text-sm text-background-300 whitespace-nowrap">国漫耽美原创力作</span>
              <span className="text-xs md:text-sm text-background-300 whitespace-nowrap">校园纯爱系列</span>
              <span className="text-xs md:text-sm text-background-300 whitespace-nowrap">奇幻异世界BL</span>
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">合作伙伴</h4>
            <p className="mt-3 text-xs md:text-sm text-background-300">
              精彩内容合作方持续扩充中，敬请期待。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-mail-line text-base"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-home-4-line text-base"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2026 腐漫画网 | 韩漫腐韩漫耽美日漫腐国漫耽美 | 好看腐漫热门推荐大全
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供交流学习，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}